<h1>{{'referentiels.list.annulationdemande.caption' | transloco }}</h1>

<!-- Référentiel Raison Annulation -->

@if (userHasReadWritePermission) {
  <p-button [size]="'small'" pRipple [rounded]="true" label="{{ 'button.add' | transloco }}" icon="pi pi-plus" class="btn-light" (onClick)="ajouterRaisonAnnulation()"></p-button>
}

<p-table
  #raisonImmobilisationTable
  [value]="raisonResult"
  selectionMode="single"
  [(selection)]="selectedRaisonAnnulation"
  dataKey="id"
  editMode="row"
  [resizableColumns]="true"
  columnResizeMode="expand"
  styleClass="p-datatable-striped"
  [scrollable]="true"
  scrollHeight="400px"
  [tableStyle]="{ 'min-width': '50rem' }"
>
  <ng-template pTemplate="caption">
    <div class="flex align-items-center justify-content-between">{{'referentiels.list.raisonAnnulationProperties.caption' | transloco }}</div>
  </ng-template>
  <ng-template pTemplate="header">
    <!-- Headers -->
    <tr>
      <th *ngIf="userHasReadWritePermission" style="width: 2%"></th>
      <th pResizableColumn pSortableColumn="raison" style="width: 40%">{{'referentiels.list.raisonAnnulationProperties.raison.header' | transloco }} <p-sortIcon field="raison" /></th>
    </tr>

    <!-- Filters Inputs -->
    <tr>
      <th *ngIf="userHasReadWritePermission"></th>
      <th>
        <p-columnFilter type="text" field="raison" matchMode="contains" placeholder="--Filtre--" ariaLabel="Filtre par raison" [showMenu]="false" [showClearButton]="false" />
      </th>
    </tr>
  </ng-template>

  <!-- Body -->
  <ng-template pTemplate="body" let-rowData let-editing="editing" let-ri="rowIndex">
    <ng-container [formGroup]="raisonAnnulationForm">
      <tr [pSelectableRow]="rowData" [pEditableRow]="rowData" (click)="onRaisonAnnulationSelect(rowData)">
        <td *ngIf="userHasReadWritePermission">
          <!-- Column for edit/save buttons -->
          <div class="flex align-items-center justify-content-center">
            <button *ngIf="!editing && userHasReadWritePermission" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" class="p-button-sm" pTooltip="{{ 'button.edit' | transloco }}" (click)="modifierRaisonAnnulation(rowData, ri)"></button>
            <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" class="p-button-sm" size="small" pTooltip="{{ 'button.validate' | transloco }}" (click)="validerModifsRaisonAnnulation(rowData)"></button>
            <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" class="p-button-sm" size="small" pTooltip="{{ 'button.cancel' | transloco }}" (click)="annulerModifsRaisonAnnulation(rowData, ri)"></button>
          </div>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" formControlName="raison" />
            </ng-template>
            <ng-template pTemplate="output">
              {{ rowData.raison }}
            </ng-template>
          </p-cellEditor>
        </td>
      </tr>
    </ng-container>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="5">{{ 'jgrid.defaults.emptyrecords' | transloco }}.</td>
    </tr>
  </ng-template>

  <ng-template pTemplate="summary">
    <div class="flex align-items-center justify-content-between">{{ 'jgrid.defaults.numberOfResult' | transloco }}at : {{ raisonResult ? raisonResult.length : 0 }}</div>
  </ng-template>
</p-table>

<!-- Référentiel Conséquence Annulation -->

@if (userHasReadWritePermission) {
  <p-button [size]="'small'" pRipple [rounded]="true" label="{{ 'button.add' | transloco }}" icon="pi pi-plus" class="btn-light" (onClick)="ajouterConsequenceAnnulation()"></p-button>
}

<p-table
  #lieuImmobilisationTable
  [value]="consequenceResult"
  selectionMode="single"
  [(selection)]="selectedConsequenceAnnulation"
  dataKey="id"
  editMode="row"
  [resizableColumns]="true"
  columnResizeMode="expand"
  styleClass="p-datatable-striped"
  [scrollable]="true"
  scrollHeight="400px"
  [tableStyle]="{ 'min-width': '50rem' }"
>
  <ng-template pTemplate="caption">
    <div class="flex align-items-center justify-content-between">{{'referentiels.list.consequenceAnnulationProperties.caption' | transloco }}</div>
  </ng-template>
  <ng-template pTemplate="header">
    <!-- Headers -->
    <tr>
      <th *ngIf="userHasReadWritePermission" style="width: 2%"></th>
      <th pResizableColumn pSortableColumn="lieu" style="width: 40%">{{'referentiels.list.consequenceAnnulationProperties.consequence.header' | transloco }} <p-sortIcon field="lieu" /></th>
    </tr>

    <!-- Filters Inputs -->
    <tr>
      <th *ngIf="userHasReadWritePermission"></th>
      <th>
        <p-columnFilter type="text" field="consequence" matchMode="contains" placeholder="--Filtre--" ariaLabel="Filtre par lieu" [showMenu]="false" [showClearButton]="false" />
      </th>
    </tr>
  </ng-template>

  <!-- Body -->
  <ng-template pTemplate="body" let-rowData let-editing="editing" let-ri="rowIndex">
    <ng-container [formGroup]="consequenceAnnulationForm">
      <tr [pSelectableRow]="rowData" [pEditableRow]="rowData" (click)="onConsequenceAnnulationSelect(rowData)">
        <td *ngIf="userHasReadWritePermission">
          <!-- Column for edit/save buttons -->
          <div class="flex align-items-center justify-content-center">
            <button *ngIf="!editing && userHasReadWritePermission" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" class="p-button-sm" pTooltip="{{ 'button.edit' | transloco }}" (click)="modifierConsequenceAnnulation(rowData, ri)"></button>
            <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" class="p-button-sm" size="small" pTooltip="{{ 'button.validate' | transloco }}" (click)="validerModifsConsequenceAnnulation(rowData)"></button>
            <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" class="p-button-sm" size="small" pTooltip="{{ 'button.cancel' | transloco }}" (click)="annulerModifsConsequenceAnnulation(rowData, ri)"></button>
          </div>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" formControlName="consequence" />
            </ng-template>
            <ng-template pTemplate="output">
              {{ rowData.consequence }}
            </ng-template>
          </p-cellEditor>
        </td>
      </tr>
    </ng-container>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="5">{{ 'jgrid.defaults.emptyrecords' | transloco }}.</td>
    </tr>
  </ng-template>

  <ng-template pTemplate="summary">
    <div class="flex align-items-center justify-content-between">{{ 'jgrid.defaults.numberOfResult' | transloco }}at : {{ consequenceResult ? consequenceResult.length : 0 }}</div>
  </ng-template>
</p-table>

<p-toast />
